import dynamic from 'next/dynamic'

export const FeatureSectionThreeColumn = dynamic(
    () => import('./feature-section-three-column'),
)
